import { Action, Dispatch } from "redux";
import {
  DeleteBandDetails,
  DeleteOutputConfigDetails,
  DeleteOutputConfigElement,
  Environments
} from "@emisgroup/cohort-builder-kit";
import { setNotification } from "../../../utilities/HttpRequest/Script";
import { NotificationType } from "../../Notification/redux/Types";
import { ProgressSpinnerSlice } from "../../ProgressSpinner/Index";
import { handleException } from "../../../ErrorMessages/helper";
import { FetchBandingDetails } from "./Banding/Script";
import {
  DELETE_ACTION_TYPE,
  DELETE_BAND_MSG,
  DELETE_CONFIG_MSG,
  DELETE_OUTPUT_MSG
} from "./Constant";
import { DeleteTypes } from "./OutputConfigLandingPage/OutputConfigList/Constants";
import { FetchOutputConfigList } from "./OutputConfigLandingPage/OutputConfigList/Script";
import { FetchOutputConfigMapsList } from "./OutputMapping/OutputMappingList/Scripts";

/**
 * API call for output config, band & oput config map delete
 * @param dispatch Function to dispatch
 * @param translate Function to translate
 * @param outputConfigId Config ID
 * @param extractGuid ID of the extract
 */
export const DeleteItem = async (
  dispatch: Dispatch<Action>,
  // eslint-disable-next-line @typescript-eslint/ban-types
  translate: Function,
  outputConfigId: string,
  extractGuid: string,
  bandId: string,
  selectedConfigId: string,
  configMapId: string,
  type: string,
  env: Environments,
  accessToken: string,
): Promise<void> => {
  try {
    const request = {
      [DeleteTypes.DELETE_OUTPUT_LIST]: {
        action: DeleteOutputConfigDetails,
        actionParams: [outputConfigId, env, accessToken],
        callback: FetchOutputConfigList,
        callbackParams: [dispatch, translate, extractGuid, env, accessToken],
        progressMessage: "LoadingMessage.DeleteOutputConfig",
        notification: "Notification.DeleteConfig"
      },
      [DeleteTypes.DELETE_BAND]: {
        action: DeleteBandDetails,
        actionParams: [selectedConfigId, bandId, env, accessToken],
        callback: FetchBandingDetails,
        callbackParams: [dispatch, translate, selectedConfigId, env, accessToken],
        progressMessage: "LoadingMessage.DeleteBand",
        notification: "Notification.DeleteBand"
      },
      [DeleteTypes.DELETE_OUTPUT_MAP_LIST]: {
        action: DeleteOutputConfigElement,
        actionParams: [selectedConfigId, configMapId, env, accessToken],
        callback: FetchOutputConfigMapsList,
        callbackParams: [dispatch, translate, selectedConfigId, env, accessToken],
        progressMessage: "LoadingMessage.DeleteOutputConfigMap",
        notification: "Notification.DeleteConfigMap"
      }
    };
    const deleteMessage = {
      [DeleteTypes.DELETE_OUTPUT_LIST]: DELETE_CONFIG_MSG,
      [DeleteTypes.DELETE_BAND]: DELETE_BAND_MSG,
      [DeleteTypes.DELETE_OUTPUT_MAP_LIST]: DELETE_OUTPUT_MSG
    };
    const requestType = request[type];
    dispatch(ProgressSpinnerSlice.actions.showProgressBar(translate(requestType.progressMessage)));
    const response = await requestType.action(...requestType.actionParams);
    if (
      response && response["data"] &&
      response["data"]["payload"]["message"] === deleteMessage[type]
    ) {
      dispatch(ProgressSpinnerSlice.actions.hideProgressBar());
      setNotification(
        dispatch,
        DELETE_ACTION_TYPE,
        translate(requestType.notification),
        NotificationType.Confirmation
      );
      await requestType.callback(...requestType.callbackParams);
    }
  } catch (ex) {
    let errorType = "";

    if (type === DeleteTypes.DELETE_BAND)
      errorType = "DeleteBandingDetailErrMsg";
    else if (type === DeleteTypes.DELETE_OUTPUT_MAP_LIST)
      errorType = "DeleteOutputMappingDetailErrMsg";
    else if (type === DeleteTypes.DELETE_OUTPUT_LIST)
      errorType = "DeleteOutputConfigErrMsg";

    handleException(ex, dispatch, errorType);
  }
};
